<template>
	<div class="ivu-select ivu-select-visible ivu-select-single ivu-select-default" style="width: 150px;">
		<div tabindex="-1" class="ivu-select-selection" @click="showDown()">
			<input type="hidden" :value="currentValue" :name="name" >
			<input type="text"  :value="currentText" :placeholder="placeholder" autocomplete="off" spellcheck="false" class="ivu-select-input">
			<i class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"></i>
		</div>
		<div class="ivu-select-dropdown" style="min-width: 150px; position: absolute; will-change: top, left; transform-origin: center top; top: 92px; left: 10px;"
		 v-if="showDownBox">
			<ul class="ivu-select-not-found" style="display: none;">
				<li>无匹配数据</li>
			</ul>
			<ul class="ivu-select-dropdown-list">
				<li class="ivu-select-item" v-for="(item,i) in orgs" @click="selectPart(item)">{{item.displayName}}</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: [String, Number, Array],
				default: ''
			},
			orgs: {
				type: Array,
				default: ''
			},
			placeholder:{
				type: String,
				default: ''
			},
			name:{
				type: String,
				default: ''
			}
		},
		data() {
			return {
				showDownBox: false,
				currentValue: this.value,
				currentText: '',
			};
		},
		watch: {
			value(val) {
				this.setCurrentValue(val);
			}
		},
		methods: {
			showDown() {
				this.showDownBox = !this.showDownBox;
				this.$forceUpdate();
			},
			selectPart(item) {
				this.setCurrentValue(item.id);
				this.showDown();
				this.$emit('input', item.id);
				this.$emit('on-change', item.id);

			},
			setCurrentValue(value) {
				if (value === this.currentValue) return;
				this.currentValue = value;
				this.currentText = '';
				for (var i = 0; i < this.orgs.length; i++) {
					if (this.orgs[i].id == this.currentValue) {
						this.currentText = this.orgs[i].displayName;
						break;
					}
				}
			},
		},

	}
</script>

<style>
</style>
